import { isUndefined } from "../predicate/predicate.js";
import { isShadowRoot } from "./predicates.js";
//#region src/dom/walk-ancestors.ts
/** Walks an element and its ancestors until the callback returns a defined value. */
function walkAncestors(start, callback, options = {}) {
	if (!start || typeof document === "undefined") return;
	let node = start;
	while (node) {
		const value = callback(node);
		if (!isUndefined(value)) return value;
		node = options.composed ? getComposedParent(node) : node.parentElement;
	}
}
function getComposedParent(element) {
	if (element.assignedSlot) return element.assignedSlot;
	if (element.parentElement) return element.parentElement;
	const root = element.getRootNode();
	return isShadowRoot(root) ? root.host : null;
}
//#endregion
export { walkAncestors };

//# sourceMappingURL=walk-ancestors.js.map